module.exports = __webpack_public_path__ + "media/images/register-71e6b5564b0b449fe72350e7a667cd5b.png";